"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var mobx_react_1 = require("mobx-react");
var TeachingBubble_1 = require("office-ui-fabric-react/lib/TeachingBubble");
var Button_1 = require("office-ui-fabric-react/lib/Button");
var owa_lightning_1 = require("owa-lightning");
var owa_options_strings_1 = require("owa-strings/owa-options-strings");
var AddStorageAccountCallout = /** @class */ (function (_super) {
    tslib_1.__extends(AddStorageAccountCallout, _super);
    function AddStorageAccountCallout() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.onClose = function () {
            owa_lightning_1.lighted(_this.props.lid);
        };
        return _this;
    }
    AddStorageAccountCallout.prototype.render = function () {
        var gotItButtonProps = {
            buttonType: Button_1.ButtonType.primary,
            children: owa_options_strings_1.default.options_callout_addStorageAccount_button,
            onClick: this.onClose,
        };
        return (React.createElement(TeachingBubble_1.TeachingBubble, { calloutProps: {
                beakWidth: 15,
                directionalHint: 12 /* rightCenter */,
                minPagePadding: 50,
                gapSpace: 20,
            }, targetElement: this.props.target(), hasCloseIcon: true, onDismiss: this.onClose, hasSmallHeadline: true, headline: owa_options_strings_1.default.options_callout_addStorageAccount_title, primaryButtonProps: gotItButtonProps }, owa_options_strings_1.default.options_callout_addStorageAccount_body));
    };
    AddStorageAccountCallout = tslib_1.__decorate([
        mobx_react_1.observer,
        owa_lightning_1.lightable
    ], AddStorageAccountCallout);
    return AddStorageAccountCallout;
}(React.Component));
exports.AddStorageAccountCallout = AddStorageAccountCallout;
//# sourceMappingURL=AddStorageAccountCallout.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/options/config/mail/owa-storage-accounts-option/lib/components/AddStorageAccountCallout.js
// module id = 5001
// module chunks = 2